<template>
    <table-ish>
        <tasks-list-item
            v-for="task in tasks"
            :key="task.uuid"
            :task="task"
            @success="$emit('success')"
        />
    </table-ish>
</template>

<script>
    import TasksListItem from './tasks-list-item'

    export default {
        components: {
            TasksListItem
        },
        props: {
            tasks: {
                type: Array,
                required: true
            }
        }
    }
</script>
